import { isNativePlatformAndroid, isNativePlatformIOS } from '../../components/helper/Platform';
import { getAuthTokenAndoid } from './get-auth-token-android';
import { getAuthTokenIos } from './get-auth-token-ios';
import { getAuthTokenWeb } from './get-auth-token-web';

export function getAuthToken(): Promise<string> {
	return new Promise((resolve) => {
		if (isNativePlatformIOS()) {
			return getAuthTokenIos(resolve);
		}
		if (isNativePlatformAndroid()) {
			return getAuthTokenAndoid(resolve);
		}
		return getAuthTokenWeb(resolve);
	});
}
